import React from 'react'
import {WarningOutlined} from '@ant-design/icons'

export const WarningIcon: React.FC = () => (
    <WarningOutlined style={{color: 'red', marginRight: '8px'}} />
)
